import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { authenticateUserWithAccessToken } from "./redux/slices/auth";
import { getStorageToken } from "./config/firebase";
import Routes from "./route";

const App = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    const authenticate = async () => {
      if (!user && getStorageToken()) {
        try {
          await dispatch(authenticateUserWithAccessToken());
        } catch (e) {
          console.error("Session restore failed:", e);
        }
      }
    };

    void authenticate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="h-screen bg-gray-50 dark:bg-gray-900">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Routes />
    </div>
  );
};

export default App;
